import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { convertTimeTo12Hr } from 'utils/bolt/showtimes';
import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import Link from 'components/bolt/link/link';
import { getProviderValues } from 'utils/bolt/showtimes';
import { metaApi } from 'utils/bolt/metaApi';
import DeviceDetector from 'device-detector-js';

import s from 'components/bolt/showtimes/screening.sss';

export default class Screening extends Component {
	constructor(props) {
		super(props);
		this.openInterstitial = this.openInterstitial.bind(this);
		this.linkClick = this.linkClick.bind(this);
	}

	getLinks() {
		let props = this.props;

		let comingSoonShowDeeplink = accessNested(props, 'showtimesAppData.cta.comingSoonShowDeeplink', false);

		let screening = props.screening;
		let country = (props.theater.country || '').toLowerCase();
		let providersData = accessNested(props, 'showtimesAppData.providers', {});

		if (providersData.disableLinksForCtas) {
			let providersValues = getProviderValues(providersData, 'disableLinksForCtas');
			let disableLinksForCtasCountry = providersValues[country] || providersValues.base || null;

			if (disableLinksForCtasCountry !== null) {
				if (typeof disableLinksForCtasCountry === 'string') {
					disableLinksForCtasCountry = disableLinksForCtasCountry.split(',');
				}

				disableLinksForCtasCountry = disableLinksForCtasCountry
					.map(x => +(x.trim()))
					.filter(x => x !== 0);

				if (disableLinksForCtasCountry.indexOf(screening.cta) !== -1) {
					return [];
				}
			}
		}

		if (screening.cta === 2 && !comingSoonShowDeeplink) {
			let links = [];
			if (props.theater.url) {
				links.push({ provider: 'direct', link: props.theater.url });
			}
			return links;
		}
		return Object.entries(screening?.link || {}).map(([provider, link]) => ({ provider, link })).filter(e => e.link);
	}

	openInterstitial() {
		const { screening, theater, mode, isPreviewPanelScreening, isMultiMovie } = this.props;

		if (isPreviewPanelScreening) {
			this.trackTimeSelection();
			return Store.emit('OPEN_PREVIEW_PANEL_PROVIDER_INTERSTITIAL', {
				screening,
				theater
			});
		}

		this.trackTimeSelection();
		Store.emit('OPEN_PROVIDER_INTERSTITIAL', {
			screening,
			theater,
			mode,
			isMultiMovie
		});
	}

	async linkClick(e) {
		this.trackTimeSelection();

		let props = this.props;
		if (props.trackConversion) {
			props.trackConversion(props.theater, props.screening, e.currentTarget.getAttribute('data-provider'), props.mode, e.currentTarget.href);
		}

		const activeGroups = window.OptanonActiveGroups?.split(',').filter(Number);
		if (activeGroups?.length && activeGroups?.length <= 2 && activeGroups[0] === '1') {
			return;
		}

		const store = Store.get();
		const metaAPIEnabled = accessNested(store, 'appData.options.metaApi.enableConversionApi', false);
		if (metaAPIEnabled) {
			let links = this.getLinks();
			const deviceDetector = new DeviceDetector();
			const device = deviceDetector.parse(navigator.userAgent);
			const metaClientId = accessNested(store, 'appData.options.metaApi.clientId', '');
			try {
				await metaApi(
					'POST',
					{},
					{
						event_name: 'Schedule',
						event_source_url: links[0]?.link,
						client_user_agent: `${device.client.name}/${device.client.version} (${device.os.name}; ${device.os.version};) ${navigator.language}`,
						client_id: metaClientId
					}
				);
			} catch (err) {
				console.error(err);
			}
		}
	}

	trackTimeSelection() {
		Store.emit('SELECT_TIME', {
			screening: this.props.screening,
			theater: this.props.theater,
			mode: this.props.mode,
			ticketType: this.props.ticketType,
			isMultiMovie: this.props.isMultiMovie,
		}, this.props.isPreviewPanelScreening ? 'previewpanel' : 'tickets');
	}

	getScreeningCta() {
		return this.props.screening.cta;
	}

	render(props) {
		let screening = props.screening;
		let screeningTime = screening.time;
		const screeningDate = screening.date;
		const { isPreviewPanelScreening } = props;
		const screeningCta = this.getScreeningCta();
		const store = Store.get();
		const fontStyles = accessNested(store, 'appData.styling.fontVariables');
		const copy = accessNested(store, 'appData.copy.baseCopy');
		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});
		const cta = accessNested(props, 'showtimesAppData.cta');
		let ariaLabel;

		if (props.showtimesAppData?.clockFormat === '12') {
			screeningTime = convertTimeTo12Hr(screeningTime);
		}

		ariaLabel = accessibilityCopy.$SCREENING_BTN_ARIA.replace('<time>', screeningTime);

		if (screeningCta !== 1 && cta && cta[screeningCta]) {
			screeningTime = copy[cta[screeningCta]] || cta[screeningCta];
			ariaLabel = screeningTime;
		}

		let screeningLabel = screeningTime;
		
		if (new Date(screeningDate) > new Date(props.selectedDate)) {
			const screeningDay = formatDateTime(screeningDate, 'ddd', copy.$DATETIME_LOCALE);
			screeningLabel = `${screeningTime} ${screeningDay}`;
		}

		let links = this.getLinks();
		let priorityProvider = this.props.priorityProviderFromQuery || this.props.showtimesAppData?.providers?.priorityProvider || '';
		let priorityProviderLink = links.find(e => e.provider === priorityProvider);
		const allButtonStyling = accessNested(Store.get(), 'appData.styling.enableDisableAllButtonStyling.showtimes');

		if (links.length === 1) {
			return (
				<Link
					class={joinClasses(s.container, s.link, fontStyles.showtimesTheaterShowtimes, isPreviewPanelScreening && s.previewPanel, allButtonStyling && s.allStyling)}
					href={links[0].link}
					target="_blank"
					rel="noopener noreferrer"
					ariaLabel={ariaLabel}
					data-provider={links[0].provider}
					onClick={this.linkClick}
				>
					{screeningLabel}
				</Link>
			);
		} else if (!!links.length && priorityProvider && priorityProviderLink) {
			return (
				<Link
					class={joinClasses(s.container, s.link, fontStyles.showtimesTheaterShowtimes, allButtonStyling && s.allStyling)}
					href={priorityProviderLink.link}
					target="_blank"
					rel="noopener noreferrer"
					ariaLabel={ariaLabel}
					data-provider={priorityProviderLink.provider}
					onClick={this.linkClick}
				>
					{screeningLabel}
				</Link>
			);
		}

		return (
			<Button
				type="time"
				class={joinClasses(s.container, allButtonStyling && s.allStyling, fontStyles.showtimesTheaterShowtimes, !links.length && s.noLink)}
				trigger={!!links.length && this.openInterstitial}
				disabled={!links.length}
				ariaLabel={ariaLabel}
			>
				{screeningLabel}
			</Button>
		);
	}
}


function getCookie(name) {
	let decodedCookie = document.cookie;
	let cookies = decodedCookie.split(';').map(c => c.trim());
	let matching = cookies.find(cookie => cookie.indexOf(name) === 0);
	return matching;
}